import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { LoadingOverlay } from '@/Components/shared';

const Auth0LoadingOverlay = ({ children }: React.PropsWithChildren) => {
    const { isLoading } = useAuth0();

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return children;
};

export default Auth0LoadingOverlay;
